angular
    .module('annexaApp')
    .component('annexaBoxDocuments',{
        templateUrl: './components/doc/annexa-box-documents/annexa-box-documents.html',
        controller:['DccumentsFactory', '$rootScope', 'AnnexaObjectBoxFactory', '$scope', 'Language', '$filter', 'AnnexaFormlyFactory', 'GlobalDataFactory', 'DialogsFactory', 'AnnexaDocumentActionsButtonFactory', 'AnnexaPermissionsFactory',
		function(DccumentsFactory, $rootScope, AnnexaObjectBoxFactory, $scope, Language, $filter, AnnexaFormlyFactory, GlobalDataFactory, DialogsFactory, AnnexaDocumentActionsButtonFactory, AnnexaPermissionsFactory) {
            var vm = this;
            vm.languageColumn = Language.getActiveColumn();
            
            $scope.$on('annexaAdvancedSearchModalAdd', function (event, args) {
                if(args.id == 'modalASDocuments') {
                    var id = undefined;
                    
                    if(args.selected && args.selected.length > 0){
                    	vm.search.searchedValue = { id: id, object: args.selected };
                        vm.search.completeAdd();
                    }

                    args.modal.close();
                }
            });

            this.$onInit = function() {
                vm.docModule = $linq(GlobalDataFactory.modules).where("x => x.url == 'annexa.doc.documents.all'").toArray();

                if(!vm.boxTitle) {
                    vm.boxTitle = 'global.literals.documents';
                }

                if(!vm.search) {
                    vm.search = {};
                }

                vm.search.addedSelect = 'x => x.document.id';
                vm.search.origin = 'doc';
                vm.search.type = 'Document';
                vm.search.processSearch = function (object) {
                    return object.name;
                }
                
                vm.entryId = undefined;
                if(vm.registerEntry && vm.registerEntry.id) {
                	vm.entryId = vm.registerEntry.id;
                }

                if(!vm.search.completeAdd) {
                    vm.search.completeAdd = function() {
                    	var newContent = [];
                    	if(vm.search.searchedValue && vm.search.searchedValue.object && Array.isArray(vm.search.searchedValue.object)){
                    		_.forEach(vm.search.searchedValue.object, function(obj){
                    			newContent.push({document: JSOG.decode(obj), relationType: 'DOCUMENT'});
                    		});
                    	}else{
                    		newContent.push({document: vm.search.searchedValue.object, relationType: 'DOCUMENT'} );
                    	}

                		if(!vm.search.saveSearch || (vm.search.saveSearch && !vm.search.addAfter)) {
                			_.forEach(newContent, function(obj){
                				vm.content.push(obj);
                        	});
                        }
                        
                		vm.search.searchedValue = { id: -1, value: '' };
                        if(vm.search.saveSearch ) {
                            vm.search.saveSearch(newContent);
                        }
                        
                        $rootScope.$broadcast('annexaBoxDocumentsUpdateCounter', { content: vm.content, relationType: 'DOCUMENT'});
                    }
                }

                vm.search.advancedSearch = function() {
                	 var docStatusRender = function(data, type, full, meta) {
                         var content = '';

                         if(DccumentsFactory.statuses && DccumentsFactory.statuses.length > 0) {
                             var status = $linq(DccumentsFactory.statuses).singleOrDefault(undefined, "x => x.id == '" + data + "'");

                             if(status) {
                                 content += '<div class="text-center">';
                                 content += '    <span class="fa-stack" title="' + $filter('translate')('global.documentState.' + status.name) + '">';
                                 content += '        <i class="fa fa-' + status.icon + ' text-' + status.style + ' text-lg fa-stack-1x"></i>';
                                 content += '    </span>';
                                 content += '</div>';
                             }
                         }

                         return content;
                     }
                	
                    var showStyledDocumentTypeAcronym = $rootScope.app.configuration.show_styled_document_type_acronym.value;
                    
                    var includeRegister = null;
                    if(vm.config && vm.config.module && vm.config.module == 'REGSALIDA'){
                    	includeRegister = true;
                    }
                    
                    var advancedSearchModal = {
                        title: 'global.literals.advanced_search_documents',
                        size: 'modal-lg',
                        filter: [
                            { id: 'code', type: 'text', order: 0, label: 'global.literals.code' },
                            { id: 'name', type: 'text', order: 1, label: 'global.literals.title' },
                            { id: 'csv', type: 'text', order: 2, label: 'global.documents.new.csv' },
                            { id: 'internalDoc', type: 'checkbox', order: 3, label: 'global.documents.internalDocument', callAux: true, model: true },
                            { id: 'template', type: 'select', order: 0, label: 'global.literals.template', dataType: 'LOCAL', data: $linq(GlobalDataFactory.templates).orderBy("x => x." + vm.languageColumn).toArray(), addAll: true, nameProperty: 'description', userChoosen: true },
                            { id: 'section', type: 'select', order: 1, label: 'global.literals.section', dataType: 'LOCAL', data: $linq(GlobalDataFactory.sections).orderBy("x => x." + vm.languageColumn).toArray(), addAll: true, nameProperty: vm.languageColumn, userChoosen: true },
                            { id: 'type', type: 'select', order: 2, label: 'global.literals.type', dataType: 'LOCAL', data: $linq(GlobalDataFactory.documentTypes).where("x => x.isPublic").toArray(), addAll: true, nameProperty: vm.languageColumn, userChoosen: true },
                            { id: 'origin', type: 'select', order: 3, label: 'global.literals.module', dataType: 'LOCAL', data: GlobalDataFactory.docModules, addAll: true, nameProperty: vm.languageColumn, callAux: true, userChoosen: true },
                            { id: 'createUser', type: 'text', order: 4, label: 'global.literals.user', callAux: true, userChoosen: true },
                            { id: 'meta', type: 'text', order: 5, label: 'global.literals.meta', callAux: true, userChoosen: true },
                            { id: 'modifyDdate', type: 'dateRange', order: 6, label: 'global.literals.modified', callAux: true, userChoosen: true },
                            { id: 'dossierNumber', type: 'text', order: 7, label: 'global.literals.numExp', callAux: true, userChoosen: true },
                            { id: 'docStatus', type: 'select', order: 8, label: 'global.literals.status', callAux: true, dataType: 'LOCAL', data: $linq(GlobalDataFactory.documentStatuses).orderBy("x => x.orderStatus").toArray(), addAll: true, nameProperty: 'nameLiteral', userChoosen: true },
                            { id: 'related', type: 'checkbox', order: 9, label: 'global.literals.showRelateds', callAux: true, preFilter:true, negated:false}
                        ],
                        tableDefinition: {
                            id: 'tableAdvancedSearchDocuments',
                            origin: 'doc',
                            objectType: 'Document',
                            sortName: 'name',
                            sort: [[3, 'asc']],
                            columns: [
                            	{ id: 'docStatus', width: '10%', title: $filter('translate')('global.literals.status'), render: docStatusRender, sortable: false },
                                { id: 'type', width: '10%', column: showStyledDocumentTypeAcronym ? new IconColumn($filter, 'global.literals.type', 'acronym', vm.languageColumn) : new ObjectTextColumn($filter, 'global.literals.type', 'acronym') , sortable: false },
                                { id: 'id', width: '10%', column: new UIRouterStateColumn($filter, 'global.literals.code', 'annexa.doc.documents.view({code: \'[data]\'})', undefined, 'var code = full.id; if(full.code) { code = full.code.substr((full.code.indexOf(full.id) - 2), full.id.toString().length + 2); } code;') },
                                { id: 'id', column: new UIRouterStateColumnNoLink($filter, 'global.literals.title', 'annexa.doc.documents.view({code: \'[data]\'})', 'name')  },
                                { id: 'createUser', width: '20%', column: new UserColumn($filter, 'global.literals.user') },
                                { id: 'modifyDate', width: '20%', column: new DateTimeColumn($filter, 'global.literals.modifyDate') }
                            ], 
                            noLoading: true,
                            skipFirstSearch: true,
                            callAuxToAdd: { added: $linq(vm.content).select("x => x.document.id").toArray(), includeRegisterEntry: includeRegister }
                        },
                        multiple: true
                    }

                    AnnexaFormlyFactory.showAnnexaAdvancedSearchModal('modalASDocuments', advancedSearchModal);
                }
                
                if(!vm.new) {
                    vm.new = {};
                }

                vm.new.newFunc = function() {
                    var preCloseModal = function(document) {
                        vm.search.searchedValue = {
                            id: document.id, value: document.name,
                            object: {
                                id: document.id,
                                docStatus: document.docStatus,
                                name: document.name,
                                profiles: document.profiles,
                                code: document.code,
                                type: document.type
                            }
                        };
                        vm.search.completeAdd();
                    }

                    DccumentsFactory.openNewDocument(undefined, preCloseModal, vm.config.module, vm.config.documentTitle)
                }

                if(vm.new.multiple) {
                    var self = this;

                    var preCloseModalFunction = function() {
                        _.forEach(this.wizard.steps[this.wizard.steps.length - 1].annexaFormly.fields[0].data.documents, function(item) {
                            if(item.procState == 'complete') {
                                vm.search.searchedValue = {
                                    id: item.docData.id, value: item.docData.name,
                                    object: {
                                        id: item.docData.id,
                                        docStatus: item.docData.docStatus,
                                        name: item.docData.name,
                                        profiles: item.docData.profiles,
                                        code: item.docData.code,
                                        type: item.docData.type
                                    }
                                };
                                vm.search.completeAdd();
                            }
                        });
                    }

                    vm.new.newMultipleFunc = function() {
                        DccumentsFactory.openMasiveDocumentModalFolder(preCloseModalFunction, self);
                    }

                    if(vm.new.multiple.scanner && $rootScope.app.configuration.load_documents_from_scan_folder.value) {
                    	vm.new.newMultipleScannerFunc = function () {
                            DccumentsFactory.openMasiveDocumentModalScan(preCloseModalFunction, self);
                        }
                    }
                    
                    if(vm.new.multiple.scanner && $rootScope.app.configuration.scanConfiguration && $rootScope.app.configuration.scanConfiguration.active && $rootScope.app.configuration.scanConfiguration.url && AnnexaPermissionsFactory.havePermission(['scan_documents'])) {
                    	var preCloseScanModalFunction = function() {
                    		if(this.createdDocument && this.createdDocument.id){
                    			vm.search.searchedValue = {
                					id: this.createdDocument.id, 
                					value: this.createdDocument.name,
                					object: this.createdDocument
                    			};
                    			vm.search.completeAdd();
                    		}
                        }
                    	
                        vm.new.getScannerFunc = function () {
                        	if(!vm.module && vm.config && vm.config.module){
                            	vm.module = vm.config.module;
                            }
                        	
                        	DccumentsFactory.openDocumentModalScanner(preCloseScanModalFunction, self);
                        }
                    }
                }
                vm.new.showNewInteroperable = false;
                if($rootScope.app.configuration.add_document_via_oberta != null){
                	vm.new.showNewInteroperable = $rootScope.app.configuration.add_document_via_oberta.value;
                }
                vm.new.newInteroperable = function(){
                    var self = this;
                    var commitModal = function(documents) {
                    	_.forEach(documents, function (doc) {
                            vm.search.searchedValue = {
                                id: doc.id, value: doc.name,
                                object: {
                                    id: doc.id,
                                    docStatus: doc.docStatus,
                                    name: doc.name,
                                    profiles: doc.profiles,
                                    code: doc.code,
                                    type: doc.type
                                }
                            };
                            vm.search.completeAdd();
                        });
                    }
                    var thirds = undefined;
                    if(vm.registerEntry){
                    	thirds = vm.registerEntry.thirds;
                    } else if(vm.config.thirdBox && vm.config.thirdBox.content) {
                    	thirds = vm.config.thirdBox.content;
                    }
                    DccumentsFactory.openNewInteroperbleModal(self, thirds, commitModal, vm.config.module, undefined);
                }
            }
        }],
        bindings: {
            boxTitle: '@?',
            permissions: '=',
            search: '=',
            new: '=',
            content: '=',
            emptyText: '@',
            isEdit: '=',
            entryType: '@?',
            config: '=',
            origin: '@',
            registerEntry: '=',
            closeBox: '=?'
        }
    })
    .component('annexaBoxDocumentsRender', {
        templateUrl: './components/doc/annexa-box-documents/annexa-box-documents-render.html',
        require: {
            objectBoxComponent: '^^annexaObjectBox'
        },
        controller:['$state', 'DialogsFactory', '$rootScope', 'AnnexaFormlyFactory', '$filter', 'globalModals', '$http', 'DccumentsFactory', 'AnnexaDocumentActionsButtonFactory', 'Language', 'AnnexaPermissionsFactory', 'GlobalDataFactory', function($state, DialogsFactory, $rootScope, AnnexaFormlyFactory, $filter, globalModals, $http, DccumentsFactory, AnnexaDocumentActionsButtonFactory, Language, AnnexaPermissionsFactory, GlobalDataFactory) {
            var vm = this;
            
            $rootScope.$on('annexaBoxDocumentsUpdateCounter', function (event, args) {
            	if (args.content && args.relationType) {
            		vm.filteredContent = $linq(args.content).where("x => (x.document.docStatus != 'NEW' ||  (x.document.docStatus == 'NEW' && x.document.physical == true)) && x.relationType == '" + args.relationType + "'").toArray();
            		if (args.relationType == 'DOCUMENT') {
            			vm.labelRegisterEntryDocs = 'success';
            			vm.labelRegisterEntryInternalDocs = '';
            			vm.labelRegisterEntryDocsPendingToUpload = '';
            			vm.counterRegisterEntryDocs = vm.filteredContent.length;
            			vm.counterRegisterEntryDocsPendingToUpload = $linq(args.content).where("x => x.document.docStatus == 'NEW' && x.document.physical == false").count();
            		} else {
            			vm.labelRegisterEntryDocs = '';
            			vm.labelRegisterEntryInternalDocs = 'success';
            			vm.labelRegisterEntryDocsPendingToUpload = '';
            			vm.counterRegisterEntryInternalDocs = vm.filteredContent.length;
            		}
            	} else if (args.content) {
            		vm.counterRegisterEntryDocs = $linq(args.content).where("x => (x.document.docStatus != 'NEW' ||  (x.document.docStatus == 'NEW' && x.document.physical == true)) && x.relationType == 'DOCUMENT'").count();
            		vm.counterRegisterEntryInternalDocs = $linq(args.content).where("x => (x.document.docStatus != 'NEW' ||  (x.document.docStatus == 'NEW' && x.document.physical == true)) && x.relationType == 'INTERNAL_DOCUMENT'").count();
            		vm.counterRegisterEntryDocsPendingToUpload = $linq(args.content).where("x => x.document.docStatus == 'NEW' && x.document.physical == false").count();
            	}
            });
            
            vm.counterRegisterEntryDocs = 0;
            vm.counterRegisterEntryInternalDocs = 0;
            vm.counterRegisterEntryDocsPendingToUpload = 0;
            vm.labelRegisterEntryDocs = '';
            vm.labelRegisterEntryInternalDocs = '';
            vm.labelRegisterEntryDocsPendingToUpload = '';
            vm.showActions = true;
            vm.filteredContent = [];
            if (vm.content) {
            	vm.filteredContent = $linq(vm.content).where("x => (x.document.docStatus != 'NEW' ||  (x.document.docStatus == 'NEW' && x.document.physical == true)) && x.relationType == 'DOCUMENT'").toArray();
            	vm.labelRegisterEntryDocs = 'success';
            	$rootScope.$broadcast('annexaBoxDocumentsUpdateCounter', { content: vm.content });
            }

            vm.filterRelationType = function (relationType) {
            	
            	vm.filteredContent = $linq(vm.content).where("x => (x.document.docStatus != 'NEW' ||  (x.document.docStatus == 'NEW' && x.document.physical == true)) && x.relationType == '" + relationType + "'").toArray();
            	if (relationType && relationType == 'DOCUMENT') {
            		vm.labelRegisterEntryDocs = 'success';
            		vm.labelRegisterEntryInternalDocs = '';
            		vm.labelRegisterEntryDocsPendingToUpload = '';
            		vm.showActions = true;
            	} else if(relationType && relationType == 'INTERNAL_DOCUMENT'){
            		vm.labelRegisterEntryDocs = '';
            		vm.labelRegisterEntryInternalDocs = 'success';
            		vm.labelRegisterEntryDocsPendingToUpload = '';
            		vm.showActions = true;
            	} else{
            		vm.labelRegisterEntryDocs = '';
            		vm.labelRegisterEntryInternalDocs = '';
            		vm.labelRegisterEntryDocsPendingToUpload = 'success';
            		vm.showActions = false;
            		vm.filteredContent = $linq(vm.content).where("x => x.document.docStatus == 'NEW' && x.document.physical == false").toArray();
            	}
            }
            
            vm.downloadDocuments = function (documents){
            	var documentsToDownload = {};
                var confirmBody = '';
                confirmBody = $filter('translate')('global.documents.confirmDownloadDocumentsList');
                confirmBody += '<br/><ul>';
                var docs = [];
                angular.forEach(documents, function (docRelated) {
                	var document = docRelated.document;
                    if (document) {
                    	confirmBody += '   <li>' + document.name + '</li>';
                    	docs.push({id:document.id});
                    }
                });
                docs = $linq(docs).orderBy("x => x.id").toArray();
                documentsToDownload.documents = JSOG.encode(docs);
                documentsToDownload.languageColumn = Language.getActiveColumn();
                confirmBody += '</ul>';
                DialogsFactory.confirm('global.literals.downloadDocuments', confirmBody)
                    .then(function() {
                        $rootScope.loading(true);
                        $http({
                            url: './api/doc/generateZip',
                            method: 'POST',
                            data: documentsToDownload,
                            headers: {
                                accept: 'application/zip'
                            },
                            responseType: 'arraybuffer',
                            cache: false
                        }).then(function (data, status, headers) {
                            var contentType = data.headers('content-type');
                            if (!contentType) {
                                contentType = 'application/zip';
                            }
                            var name = data.headers('content-disposition');
                            if (name) {
                                name = name.split(";");
                                if(vm.entryNumber){
                                	name = "Documents_"+vm.entryNumber+".zip";
                                }else if(name && name.length > 1) {
                                    name = name[1].trim().split("=");
                                    if (name && name.length > 1) {
                                        name = name[1];
                                        name = name.replace(/"/g, '');
                                    } else {
                                        name = "documents.zip";
                                    }
                                } else {
                                    name = "documents.zip";
                                }
                            } else {
                                name = "documents.zip";
                            }
                            var file = new Blob([data.data], {type: contentType});
                            if (window.navigator.msSaveOrOpenBlob) {
                                try {
                                    window.navigator.msSaveOrOpenBlob(file, name);
                                } catch (e) {
                                    console.log(e.message);
                                }
                            } else {

                                var linkElement = document.createElement('a');
                                try {
                                    var url = window.URL.createObjectURL(file);
                                    linkElement.setAttribute('href', url);
                                    linkElement.setAttribute("download", name);
                                    var clickEvent = new MouseEvent("click", {
                                        "view": window,
                                        "bubbles": true,
                                        "cancelable": false
                                    });
                                    linkElement.dispatchEvent(clickEvent);
                                } catch (ex) {
                                    console.log(ex);
                                }
                            }
                            self.close();
                        }).catch(function (error) {
                            DialogsFactory.error($filter('translate')('global.errors.errorGeneratingZip'), $filter('translate')('DIALOGS_ERROR_MSG'));
                        });
                });
            }
            
            vm.getDocStatusTitle = function (document) {
                return 'global.documentState.' + document.docStatus;
            }

            vm.getDocStatusIcon = function (document) {
                switch (document.docStatus) {
                    case 'NEW':
                        return 'fa fa-circle-o text-blue fa-lg';
                        break;
                    case 'NEW_AND_ATTACHMENT':
                        return 'fa fa-adjust text-blue fa-lg';
                        break;
                    case 'PENDING_SIGN':
                        return 'fa fa-circle text-blue fa-lg';
                        break;
                    case 'SIGNED':
                        return 'fa fa-circle text-success fa-lg';
                        break;
                    case 'REJECTED':
                        return 'fa fa-circle text-danger fa-lg';
                        break;
                    case 'COMPLETE':
                        return 'fa fa-dot-circle-o text-success fa-lg v-t';
                        break;
                    case 'ARCHIVED':
                        return 'fa fa-circle-o text-success fa-lg v-t';
                        break;

                }
            }

            vm.getDocumentPermissionsOrigin = function () {
                return $state.current.name == 'annexa.reg.input.diligences.edit' ? 'DILIGENCE' : '';
            }

            vm.delete = function(index) {
                DialogsFactory.confirm('global.literals.delete', 'global.literals.deleteDocumentBox')
                    .then(function (data) {
                        var removed = angular.copy(vm.filteredContent[index]);
                        vm.filteredContent.splice(index, 1);
                        $rootScope.$broadcast('annexaBoxDocumentsUpdateCounter', { content: vm.filteredContent, relationType: removed.relationType});

                        var indexRemove = $linq(vm.content).indexOf("x => x.document.id == " + removed.document.id);
                        if(indexRemove != -1) {
                            vm.content.splice(indexRemove, 1);
                        }

                        if(vm.isEdit) {
                            $rootScope.$broadcast('annexaBoxDocumentsDelete', { removedId: removed.document.id, origin: vm.origin});
                        }
                    }).catch(function (data) {
                    //Empty
                });
            }

			vm.associateToThird = function(document) {
                if(vm.objectBoxComponent && vm.objectBoxComponent.new && vm.objectBoxComponent.new.thirds &&  vm.objectBoxComponent.new.thirds.length > 0){
					if(document && document.id){
						var docs = [{id:document.id}];
						var modal = angular.copy(globalModals.documentRelatedToThird);
						modal.annexaFormly.model = {};
						var thirdsToAdd = angular.copy(vm.objectBoxComponent.new.thirds);
					    modal.annexaFormly.model.modal_body = {thirdsToAdd: angular.copy(thirdsToAdd)};
					    modal.annexaFormly.options = {};
						var saveDocumentRelatedToThird = function(){
							var self = this;
							if(self.annexaFormly && self.annexaFormly.model && self.annexaFormly.model.modal_body){
								var model = self.annexaFormly.model.modal_body;
								var thsAdded = [];
								_.forEach(thirdsToAdd, function(th){
									if(th && th.id){
										if(th.third && th.third.id && model['thirds_'+th.id]){
											thsAdded.push({thirdId: th.third.id, documents:docs});
										}
									}else if(th.third && th.third.id && model['thirds_'+th.third.id]){
										thsAdded.push({thirdId: th.third.id, documents:docs});
									}
								});
								if(thsAdded && thsAdded.length > 0){
									$http({
						                method: 'PUT',
						                url: './api/thirds/relatedDocuments', 
										data: thsAdded
						            }).success(function(data, status) {
										self.close();
									}).error(function(msg,code) {
										DialogsFactory.error($filter('translate')('global.literals.associateDocumentToThirdError3'));
						            });
								}
							}
						}
						AnnexaFormlyFactory.showModal('modalDocumentRelatedToThird', modal, saveDocumentRelatedToThird, false);	
					}else{
						DialogsFactory.error($filter('translate')('global.literals.associateDocumentToThirdError2'));
					}
				} else{
					DialogsFactory.error($filter('translate')('global.literals.associateDocumentToThirdError'));
				}
            }
			
			vm.manuallyAddStampRegister = function(document) {
				DialogsFactory.confirm('global.documents.confirmManuallyAddStampRegisterTitle', 'global.documents.confirmManuallyAddStampRegisterContent')
		            .then(function() {
		                $rootScope.loading(true);
		                DccumentsFactory.manuallyAddStampRegister(document.id, vm.entryId)
		                    .then(function() {
		                        $rootScope.loading(false);
		                    }).catch(function(error) {
		                        $rootScope.loading(false);
	                            DialogsFactory.error($filter('translate')('global.errors.errorManuallyAddStampRegister'), $filter('translate')('DIALOGS_ERROR_MSG'));
		                });
		            });
			}
			
			vm.documentIsExpired = function(expirationDate){
				var documentIsExpired = false;
				if(expirationDate){
					if(expirationDate instanceof Date){
						if(expirationDate < new Date()){
							documentIsExpired = true;
						}
					}else {
						if(new Date(expirationDate) < new Date()){
							documentIsExpired = true;
						}
					}
				}
				return  documentIsExpired;
			}
			
			vm.viewDocument = function(document){
				if(document) {
                    $rootScope.loading(true);
                    var windowReference = window.open();
                    DccumentsFactory.getDocContent(document.id)
                        .then(function(data) {
                        	$rootScope.loading(false);
                        	windowReference.location = data;
                    }).catch(function (error) {
                        $rootScope.loading(false);
                        windowReference.close();
                    });
                }
			}
			vm.authCopyDocument = function(document){
				 $rootScope.loading(true);
                 var windowReference = window.open();
                 DccumentsFactory.getAuthCopyContent(document.id)
                 .then(function(data) {
                	 $rootScope.loading(false);
                	 windowReference.location = data;
                 }).catch(function (error) {
                	 $rootScope.loading(false);
                     windowReference.close();
                 });
			}
			
			vm.canShowDocument = function (document) {
            	if(document && document.docStatus != 'ARCHIVED'){
                    if(AnnexaPermissionsFactory.havePermission('view_documents')) {
                        if (vm.origin && _.contains(['THIRD', 'DILIGENCE', 'DOSSIER', 'TASK', 'SEC'], vm.origin)) {
                            return true;
                        }
                        if(vm.origin != 'NOTIFICATION' && $state.current && $state.current.name && ($state.current.name == 'annexa.reg.input.entries.edit' || $state.current.name == 'annexa.reg.input.entries.new' || $state.current.name == 'annexa.reg.output.entries.new' || $state.current.name == 'annexa.reg.output.entries.edit' || $state.current.name == 'annexa.reg.view' || $state.current.name == 'annexa.reg.viewInput' || $state.current.name == 'annexa.reg.viewOutput' || $state.current.name == 'annexa.reg.viewByNumberInput') && AnnexaPermissionsFactory.havePermission('view_register_entry_documents')){
                            return true;
                        }
                        if(document && document.profiles) {
                            var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                            var documentProfiles = $linq(document.profiles).select("x => x.profile.id").toArray();
                            var intersect = $linq(userProfiles).intersect(documentProfiles, "(x,y) => x == y").toArray();
                            var documentTypeProfilesTotalAcces = [];
                            if(document && document.type && document.type.id){
                            	var dtype = $linq(GlobalDataFactory.documentTypes).firstOrDefault(undefined,"x => x.id == "+document.type.id);
                            	if(dtype && dtype.profilesTotalAcces){
                            		var documentTypeProfilesTotalAcces = $linq(dtype.profilesTotalAcces).select("x => x.profile.id").toArray();
                            	}
                            } 
                            var intersectDocType = $linq(userProfiles).intersect(documentTypeProfilesTotalAcces, "(x,y) => x == y").toArray();
                            return intersect.length > 0 || intersectDocType.length > 0 ;
                        } 
                    }
            	}
                return false;
            }
			
			vm.getTitleDocumentView = function(type){
				var titleDocView = "";
				if(type == "authCopy"){
					titleDocView = "[" + $filter('translate')('global.literals.seeAuthCopy') + "]";
				}else{
					titleDocView = "[" + $filter('translate')('global.literals.seeDocument') + "]";
				}
				
				return titleDocView;
			}
			vm.showViewDocument = function(document){
				if(AnnexaDocumentActionsButtonFactory.isDocumentConvertibleToPdf(document, true)){
					return true;
				}
				
				return false;
			}
        }],
        bindings: {
            content: '=',
            emptyText: '@',
            isEdit: '=',
            entryType: '@?',
            origin: '@',
            entryId: '=',
            entryNumber: '='
        }
    })